/*******************************************************************************
 *
 * Utility functions to work with the array of layers coming back from the nSITE api.
 *
 *******************************************************************************/

import { LAYER_PREVIEW, DATA_HUB, DATA_HUB_PREFIX } from "../Constants";
import { layer } from "@fortawesome/fontawesome-svg-core";

/**
 * Helper to sort layers by displayOrder property.
 */
export const sortByDisplayOrder = (layerA, layerB) => {
  const a = layerA.displayOrder;
  const b = layerB.displayOrder;

  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

/**
 * Is default layer.
 */
const isDefault = layer => layer.isDefault;

/**
 * Is base layer.
 */
const isBaseLayer = layer => layer.isBaseLayer;

/**
 * Is non-base layer.
 */
const isNonBaseLayer = layer => !layer.isBaseLayer;

/**
 * Is non-base layer.
 */
const hasGroupName = groupName => layer => layer.groupName === groupName;

/**
 * Base layers.
 */
export const findAllBaseLayers = layers => layers.filter(isBaseLayer).sort(sortByDisplayOrder);

/**
 * Default base layer.
 */
export const findDefaultBaseLayer = layers => findAllBaseLayers(layers).filter(isDefault)[0];

/**
 * Default reference layers.
 */
export const findDefaultReferenceLayer = (layers, mode) => {
  let layerName = null;
  if (mode.name === LAYER_PREVIEW) {
    layers.map(layer => {
      if (!layer.isBaseLayer) {
        layer.isDefault = false;
      }
    });
    layerName = mode.layerName;
    if (layerName && layerName.toLowerCase().indexOf(DATA_HUB_PREFIX) > -1) {
      layers.push({
        layerName: mode.layerName,
        layerType: DATA_HUB,
        displayOrder: 1000,
        isDefault: true,
        isBaseLayer: false,
        id: Math.random() * 1000,
        opacity: 0.8
      });
    }
  }
  return layers.filter(function(layer) {
    return layerName === layer.layerName;
  });
};

/**
 * Non base layers.
 */
export const findAllNonBaseLayers = layers =>
  layers.filter(isNonBaseLayer).sort(sortByDisplayOrder);

/**
 * Non base layers by group name.
 */
export const findAllNonBaseLayersByGroupName = (layers, groupName) =>
  layers.filter(hasGroupName(groupName)).sort(sortByDisplayOrder);
